import React from 'react';
import { uniq, compact } from 'lodash';
import classnames from 'classnames';

import { EnglishLevelsTableComponentFragment } from '../../../../graphql.schema';

import * as styles from './StrapiEnglishLevelsTable.module.scss';

export const StrapiEnglishLevelsTable = ({
  englishLevelGroup,
  highlightedColumns,
}: EnglishLevelsTableComponentFragment) => {
  if (!englishLevelGroup) return null;

  const levels = englishLevelGroup.englishLevels;
  const labels = uniq(compact(levels).flatMap((l) => l.certifications?.map((i) => i?.certification.toUpperCase())));
  const columns = highlightedColumns?.split(',');

  const certHeaderClass = classnames(styles.certificationRowHeader, 'has-text-weight-bold is-uppercase');
  return (
    <div className={classnames('EnglishLevelsTable--root', styles.root)}>
      {labels.map((label) => (
        <table
          key={`table-mobile-${label}`}
          className={classnames('table is-hidden-desktop', styles.table, styles.mobile)}
        >
          <thead>
            <tr>
              <th className="has-text-weight-bold">Wall Street English</th>
              <th className="has-text-weight-bold is-uppercase has-text-right">{label}</th>
            </tr>
          </thead>
          <tbody>
            {compact(levels).map((l, i) => (
              <tr key={`table-mobile-${label}-row-${i}`}>
                <td className="is-text-1">{l.name}</td>
                <td className="has-text-right is-text-1">
                  {l.certifications?.find((c) => c?.certification.toUpperCase() === label)?.correspondingLevel}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
      <table className={classnames('table is-hidden-touch', styles.table)}>
        <thead>
          <tr>
            <th className={styles.tableHeader} />
            {compact(englishLevelGroup.englishLevels).map((item, index) => (
              <th
                key={`table-cefr-${englishLevelGroup.id}-${index}`}
                className={classnames(
                  { [styles.highlight]: columns?.includes((index + 1).toString()) },
                  styles.tableHeader,
                )}
              >
                <span className={styles.prefix}>Wall Street English</span>
                <span className={classnames('has-text-weight-bold is-uppercase is-5 title', styles.levelName)}>
                  {item.name}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {labels.map((label) => (
            <tr key={`tr-${label}`}>
              <td className={certHeaderClass}>{label}</td>
              {compact(englishLevelGroup.englishLevels).map((item, index) => (
                <td
                  key={`td-${label}-${index}`}
                  className={classnames({ [styles.highlight]: columns?.includes((index + 1).toString()) })}
                >
                  {item.certifications?.find((c) => c?.certification.toUpperCase() === label)?.correspondingLevel}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
